import { Link } from 'react-router-dom'
import { BookOpen, CircleHelp, ListChecks } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { checklistSummary } from '@/src/lib/onboarding/tour-machine'
import { useOnboarding } from './Onboarding'

/** Help in the top bar: Getting started (the guided tours) and the documentation. */
export function HelpMenu() {
  const { tours, progress, openChecklist } = useOnboarding()
  const { done, total } = checklistSummary(progress, tours)

  return (
    // Not modal: a modal menu that opens a dialog can leave the page unclickable after both close.
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Help" data-tour="header-help">
          <CircleHelp className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Help</DropdownMenuLabel>
        <DropdownMenuItem onSelect={openChecklist}>
          <ListChecks />
          <span className="flex-1">Getting started</span>
          {total > 0 && (
            <span className="text-xs text-muted-foreground tabular-nums">
              {done}/{total}
            </span>
          )}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/docs">
            <BookOpen />
            Documentation
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
